import { makeAutoObservable } from 'mobx';
import {EarningsFormatter} from 'shared/tools';
import {t} from 'shared/core';

class JobTimelineEntryViewModel {
  record;
  expanded = false;
  isFirst = false;
  isLast = false;
  earningsFormatter;

  constructor(employmentRecord) {
    makeAutoObservable(this);

    this.record = employmentRecord;
    this.earningsFormatter = new EarningsFormatter(this.record);
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  get expandedText() {
    return this.expanded ? 'employees.profile.role.- Hide Details' : 'employees.profile.role.+ Show Details';
  }

  get changedByTitle() {
    return this.record.wasUpdated ? 'employees.profile.role.Changed by' : 'employees.profile.role.Created by';
  }

  get hasChangedBySection() {
    return !!this.record.author;
  }

  get insurableEarningsLabel() {
    return t(
      'employees.profile.role.COMPUTED_INSURABLE_EARNINGS',
      {insurableEarnings: this.earningsFormatter.formattedTotalInsurableEarnings}
    );
  }
}

export default JobTimelineEntryViewModel;
